<template>
  <QHeader reveal class="bg-white print-hide">
    <SAITabsHeader
      :class="['tabs-header', { 'q-pb-md': !tabs.length }]"
      :tabs="tabs"
      :right-action-loading="savingForExit"
      :disable="disable"
      :left-action-label="'Exit'"
      :right-action-label="rightActionLabel"
      @input="$emit('tab:selected', $event)"
      @click:left-action="$emit('exit')"
      @click:right-action="$emit('exit:save')"
    />
  </QHeader>
</template>

<script>
import { QHeader } from 'quasar';
import { SAITabsHeader } from 'ecx.saigon.ui.common';

/**
 * This component represents the header which is to be displayed as part of all page layouts.
 */
export default {
  name: 'ProgressHeader',
  props: {
    savingForExit: Boolean,
    disable: Boolean,
    tabs: {
      type: Array,
      default: () => []
    },
    disableSaveAndClose: Boolean
  },
  computed: {
    rightActionLabel() {
      return this.disableSaveAndClose ? null : 'Save and close';
    }
  },
  components: {
    QHeader,
    SAITabsHeader
  }
};
</script>
